import { createRouter, createWebHistory } from 'vue-router';
// 一级分页组件
import home from '@/components/home.vue';
import company from '@/components/company.vue';
import products from '@/components/products.vue';
import directions from '@/components/directions.vue';
import about from '@/components/about.vue';
import honors from '@/components/honors.vue';
//认证页组件
import TechnologyCertification from '@/components/honors/TechnologyCertification.vue';
import ExperimentReport from '@/components//honors/ExperimentReport.vue';

// 产品页组件
import GGD from '@/components/products/GGD.vue';
import XL from '@/components/products/XL.vue';
import FKPX from '@/components/products/FKPX.vue';
import highXB from '@/components/products/highXB.vue';
import highKYN28 from '@/components/products/highKYN28.vue';
import double from '@/components/products/double.vue';
import PZ30 from '@/components/products/PZ30.vue';
import GCS from '@/components/products/GCS.vue';
import BP from '@/components/products/BP.vue';
import BpXj from '@/components/products/BpXj.vue';
import XhGs from '@/components/products/XhGs.vue';
import YB from '@/components/products/YB.vue';
import PLC from '@/components/products/PLC.vue';
import welcome1 from '@/components/products/welcome1.vue';
// 说明页组件
import bpDirection from '@/components/directions/bpDirection.vue';
import bp11dsbDirection from '@/components/directions/bp11dsbDirection.vue';
import fan1Direction from '@/components/directions/fan1Direction.vue';
import fan2Direction from '@/components/directions/fan2Direction.vue';
import bp12bgDirection from '@/components/directions/bp12bgDirection.vue';
import bp12ldDirection from '@/components/directions/bp12ldDirection.vue';
import bp1dDirection from '@/components/directions/bp1dDirection.vue';
import doublePwDirection from '@/components/directions/doublePwDirection.vue';
import doubleWysbDirection from '@/components/directions/doubleWysbDirection.vue';
import abbColDirection from '@/components/directions/abbColDirection.vue';
import xfStarDirection from '@/components/directions/xfStarDirection.vue';
import welcome2 from '@/components/directions/welcome2.vue';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/',
      name: 'home',
      component: home
    },
    {
      path: '/company',
      name: 'company',
      component: company
    },
    {
      path: '/honors',
      name: 'honors',
      component: honors,
      redirect: '/honors/TechnologyCertification',
      children: [
        { path: 'TechnologyCertification', name: 'TechnologyCertification', component: TechnologyCertification },
        { path: 'ExperimentReport', name: 'ExperimentReport', component: ExperimentReport }
      ]
    },
    {
      path: '/products',
      name: 'products',
      redirect: '/products/welcome1',
      component: products,
      children: [
        { path: 'welcome1', name: 'welcome1', component: welcome1 },
        { path: 'GGD', name: 'GGD', component: GGD },
        { path: 'XL', name: 'XL', component: XL },
        { path: 'FKPX', name: 'FKPX', component: FKPX },
        { path: 'highXB', name: 'highXB', component: highXB },
        { path: 'highKYN28', name: 'highKYN28', component: highKYN28 },
        { path: 'double', name: 'double', component: double },
        { path: 'PZ30', name: 'PZ30', component: PZ30 },
        { path: 'GCS', name: 'GCS', component: GCS },
        { path: 'BP', name: 'BP', component: BP },
        { path: 'BpXj', name: 'BpXj', component: BpXj },
        { path: 'XhGs', name: 'XhGs', component: XhGs },
        { path: 'YB', name: 'YB', component: YB },
        { path: 'PLC', name: 'PLC', component: PLC }
      ]
    },
    {
      path: '/directions',
      name: 'directions',
      redirect: '/directions/welcome2',
      component: directions,
      children: [
        { path: 'welcome2', name: 'welcome2', component: welcome2 },
        { path: 'bpDirection', name: 'bpDirection', component: bpDirection },
        { path: 'bp11dsbDirection', name: 'bp11dsbDirection', component: bp11dsbDirection },
        { path: 'fan1Direction', name: 'fan1Direction', component: fan1Direction },
        { path: 'fan2Direction', name: 'fan2Direction', component: fan2Direction },
        { path: 'bp12bgDirection', name: 'bp12bgDirection', component: bp12bgDirection },
        { path: 'bp12ldDirection', name: 'bp12ldDirection', component: bp12ldDirection },
        { path: 'bp1dDirection', name: 'bp1dDirection', component: bp1dDirection },
        { path: 'doublePwDirection', name: 'doublePwDirection', component: doublePwDirection },
        { path: 'doubleWysbDirection', name: 'doubleWysbDirection', component: doubleWysbDirection },
        { path: 'abbColDirection', name: 'abbColDirection', component: abbColDirection },
        { path: 'xfStarDirection', name: 'xfStarDirection', component: xfStarDirection }
      ]
    },
    {
      path: '/about',
      name: 'about',
      component: about
    },
    {
      path: '/:pathMatch(.*)*',
      redirect: '/'
    }
  ]
});

export default router;